module.exports = __webpack_public_path__ + "img/pd-img43.3866a492.jpg";